<template>
  <Modal v-model="visible" title="批量导入修改" :loading="loading" @on-ok="handleOk" @on-cancel="handleCancel">
    <div style="margin-top:15px">
      <span>选择导入文件：</span>
      <div style="margin-top:10px;">
        <dytUpload
          ref="uploadRef"
          file-name="excelFile"
          :headers="headObj"
          :show-upload-list="false"
          :on-success="handleSuccess"
          :on-format-error="handleFormatError"
          :on-error="handleError"
          :action="uploadUrl"
          :format="['xlsx', 'xls']"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
          :before-upload="handleBeforeUpload"
        >
          <Button>选择文件</Button>
          <Button type="text" @click.stop="downloadTemplate" style="color:#2d8cf0;margin-left:10px;">下载模板</Button>
        </dytUpload>
        <div v-if="file !== null" class="mt10">{{ file.name }}</div>
      </div>
    </div>
  </Modal>
</template>

<script>
import api from '@/api/api';

export default {
  name: 'batchImportModifyModal',
  props: {
    headObj: {
      type: Object,
      default: () => ({})
    },
    filenodeViewTargetUrl: {
      type: String,
      default: ''
    },
    // 是否是产品开发主管
    productDeveloperSupervisor: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    businessDeptIds () {
      if (!this.$store.getters['authUserInfo'] || !this.$store.getters['authUserInfo'].securityUser) return '';
      return this.$store.getters['authUserInfo'].securityUser.businessDeptIds;
    },
  },
  data () {
    return {
      visible: false,
      loading: true,
      file: null,
      uploadUrl: api.productImportUpdate // 后端接口
    }
  },
  methods: {
    open () {
      this.resetLoading();
      const paramsString = `businessDeptIds=${this.businessDeptIds}&productDeveloperSupervisor=${this.productDeveloperSupervisor}`;
      this.file = null;
      this.visible = true;
      this.uploadUrl = `${api.productImportUpdate}?${paramsString}`; // 后端接口
    },
    handleBeforeUpload (file) {
      this.file = file;
      return false;
    },
    handleSuccess (res) {
      if (res.code === 0) {
        this.$Message.success('导入成功');
        this.visible = false;
        this.file = null;
        this.$emit('refreshTable');
      } else {
        this.resetLoading();
      }
    },
    handleFormatError () {
      this.$Message.error('请选择xlsx或xls格式的文件');
      this.resetLoading();
    },
    handleError () {
      this.$Message.error('上传失败');
      this.resetLoading();
    },
    handleOk () {
      if (!this.file) {
        this.$Message.error('请选择导入文件');
        this.resetLoading();
        return;
      }
      this.$refs.uploadRef.post(this.file);
    },
    handleCancel () {
      this.file = null;
    },
    downloadTemplate () {
      // TODO: 等后端接口出来后替换模板下载地址
      let newTab = window.open('about:blank');
      const templateUrl = '/product-service/template/importUpdate.xlsx';
      newTab.location.href = `${this.filenodeViewTargetUrl}${templateUrl}`;
    },
    resetLoading () {
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true;
      });
    }
  }
}
</script>
